// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import * as bootstrap from 'bootstrap'
import Header from '@/components/Header.vue'
import Utils from '@/utils/utils'
import swal from 'sweetalert'
import { orderFactory } from '@/http/order'
import { masterDataFactory } from '@/http/master-data'
import { customerFactory } from '@/http/customer'
import { usFactory } from '@/http/uang-sekolah'
import constants from '@/constants/constants'
declare let html2pdf: any
declare let snap: any

@Options({
  components: {
    Header
  },
  data () {
    return {
      currentSort: 'name',
      currentSortDir: 'asc',
      billDetails: [],
      months: [],
      school: {
        name: ''
      },
      student: {
        name: '',
        class: {
          name: ''
        },
        student_profile: {
          nis: ''
        }
      },
      totalPaid: 0,
      billId: 0,
      data_master: {
        months: '1',
        school: '1'
      },
      orderId: this.$route.params.order_id,
      order: {
        total_charge: 0,
        total_payment: 0,
        id: 0,
        invoice_no: '',
        status: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        payment_date: '',
        expired_date: '',
        us_order_id: 0,
        us_order: {
          status: 0
        }
      },
      billUserInstallments: [],
      constants: constants,
      customInvoice: false,
      additional_data: '',
      xenditModal: null as any,
      xenditInvoice: '',
      bcaModal: null as any,
      bca: {
        bank_name: '',
        orderId: '',
        invoice_number: '',
        va_number: '',
        va_number_nobill: '',
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_payment: 0
      },
      canUploadReference: false,
      referenceFile: null as any
    }
  },
  methods: {
    print: function () {
      if (typeof html2pdf === 'undefined') {
        swal('Invoice Belum siap', '', 'error')
        return
      }
      // Get HTML to print from element
      const prtHtml = document.getElementById('print')?.innerHTML

      const opt = {
        margin: 0,
        filename: `invoice_#${this.order.invoice_no}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      }
      html2pdf().from(prtHtml).set(opt).save()
    },
    sort: function (s: any) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    toLocaleString: function (val: any) {
      return Utils.toLocaleString(val)
    },
    beautifyDatetime: function (val: any) {
      return Utils.beautifyDatetime(val)
    },
    getMonth: function (date: any) {
      if (date != '' && date != undefined) {
        const d = date.split('-')
        const month = d[2]
        return this.months[month].id
      } else {
        return ''
      }
    },
    loadData: function () {
      Promise.all([
        orderFactory.detailOrder(this.orderId)
      ]).then(results => {
        this.order = results[0].data.order
        this.student = results[0].data.student
        this.billUserInstallments = results[0].data.bill_user_installments
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    loadDataMaster: function () {
      Promise.all([
        masterDataFactory.master_datas(this.data_master)
      ]).then(results => {
        this.months = results[0].data.months
        this.school = results[0].data.school
        this.loadData()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    formatPrice (value) {
      const val = Math.round(value / 1).toFixed(0).replace('.', ',')
      return 'IDR ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    addPdfHtmlJS () {
      const htmljs = document.createElement('script')
      htmljs.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.2/html2pdf.bundle.js')
      document.head.appendChild(htmljs)
    },
    addSnapJS () {
      const uangsekolah = document.createElement('script')
      const instance = String(localStorage.getItem('instance'))
      uangsekolah.setAttribute('src', localStorage.getItem('base_url') + '/' + instance + '/us/snap.js')
      document.head.appendChild(uangsekolah)
    },
    handleExpiredPayment: function () {
      const spp_user_bill_ids: any = []
      this.billUserInstallments.forEach((value: any) => {
        spp_user_bill_ids.push(value.spp_bill_user_id)
      })
      this.$router.push({
        path: '/bill',
        query: {
          repay_user_bill_ids: spp_user_bill_ids
        }
      })
    },
    handlePayment: function (us_order_id: any) {
      Promise.all([
        usFactory.getUSToken(us_order_id)
      ]).then(results => {
        const token_order_id = results[0].data.us_order.token
        const us_order = results[0].data.us_order
        const order = results[0].data.order
        const merchant = us_order.merchant
        const merchant_config = merchant.configs || {}
        const client_key = merchant_config.client_key || ''
        const snap_js_endpoint = merchant_config.snap_js_endpoint || ''

        if (!merchant) {
          swal('Gagal melakukan request', '', 'error')
          return
        }

        if (merchant.type == 'midtrans') {
          loadSnapJS(snap_js_endpoint, client_key, function () {
            if (typeof snap === 'undefined') {
              swal('Halaman Belum siap', '', 'error')
              return
            }

            snap.pay(token_order_id, {
              uiMode: 'qr',
              gopayMode: 'qr',
              onSuccess: function (result: any) {
                console.log('success')
                return false
              },
              onPending: function (result: any) {
                console.log('pending')
                return false
              },
              onError: function (result: any) {
                console.log('error')
                return false
              },
              onClose: function () {
                console.log('customer closed the popup without finishing the payment')
                return false
              }
            })
          })
        } else if (merchant.type == 'xendit') {
          this.xenditInvoice = us_order.link
          this.xenditModal.show()
        } else {
          const bankNames = {
            bca: 'BCA',
            panin: 'Panin',
            cimb: 'CIMB',
            bcah2h: 'BCA',
            permata: 'Permata',
            ocbc: 'OCBC',
            mandiri: 'Mandiri',
            bni: 'BNI',
            bri: 'BRI'
          }

          this.bca.orderId = us_order.order_id
          this.bca.va_number = us_order.custom_field1
          if (merchant.type.includes('offline')) {
            this.bca.va_number_nobill = us_order.custom_field2
            this.bca.bank_name = bankNames[merchant.type.split('-')[0]]
          } else {
            this.bca.bank_name = bankNames[merchant.type]
          }
          this.bca.amount = us_order.total_amount
          this.bca.convenience_fee = order.convenience_fee
          this.bca.merchant_fee = order.merchant_fee
          this.bca.total_discount = order.total_discount
          this.bca.ppn = order.ppn
          this.bca.total_payment = order.total_payment
          this.bcaModal.show()
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      }).finally(() => {
        this.loadData()
      })
      return false
    },
    handlePayment2: function (order: any) {
      this.bca.invoice_number = order.invoice_no
      this.bca.va_number = order.custom_field2
      this.bca.bank_name = order.custom_field3
      this.bca.amount = order.total_amount
      this.bca.convenience_fee = order.convenience_fee
      this.bca.merchant_fee = order.merchant_fee
      this.bca.total_discount = order.total_discount
      this.bca.ppn = order.ppn
      this.bca.total_payment = order.total_payment

      this.referenceFile = (order && order.reference && order.reference.file_path) ? order.reference.file_path : null

      this.bcaModal.show()
      this.canUploadReference = true
    }
  },
  computed: {
    sortedBillDetails: function () {
      return this.billDetails.sort((a: any, b: any) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    }
  },
  async mounted () {
    await this.loadDataMaster()
    this.addPdfHtmlJS()
    this.addSnapJS()

    const xenditModal = document.getElementById('xenditModal')
    if (xenditModal != null) {
      this.xenditModal = new bootstrap.Modal(xenditModal)
    }

    const bcaModal = document.getElementById('bcaModal')
    if (bcaModal != null) {
      this.bcaModal = new bootstrap.Modal(bcaModal)
    }
  }
})

export default class BillInvoice extends Vue {}
